import { Confidence, formatCents, type Estimate } from '@/components/work-orders';

/** The whole of a bought list's order, or why there is no figure for it yet. */
export type ListTotal = { kind: 'counting' } | { kind: 'failed' } | { kind: 'priced'; cents: number; withRegistration: boolean };

/**
 * What the person pays for a bought list: the list, the texts to it, and the one-time registration a
 * first send owes (0 when none is owed, null while unknown). The card and the order bar both show this,
 * so they never disagree. A total is never partial or stale: an estimate, an unknown part or a failed
 * price leaves it without a figure.
 */
export function listTotal(parts: { list: Estimate | null; texts: Estimate | null; registrationCents: number | null; failed: boolean }): ListTotal {
  if (parts.failed) return { kind: 'failed' };
  const { list, texts, registrationCents } = parts;
  if (list?.confidence !== Confidence.Exact || texts?.confidence !== Confidence.Exact || registrationCents === null) {
    return { kind: 'counting' };
  }
  return { kind: 'priced', cents: list.value + texts.value + registrationCents, withRegistration: registrationCents > 0 };
}

/** A total as its dollars and its cents, so the cents can be set smaller: "$742" and ".46". */
export function splitDollars(cents: number): { dollars: string; cents: string } {
  const text = formatCents(cents);
  const point = text.lastIndexOf('.');
  return { dollars: text.slice(0, point), cents: text.slice(point) };
}
